export default __webpack_public_path__ + "static/media/feature_4@2x.841bcf13.png";